export const ENDPOINT_BANKID_PRELOADED = 'ENDPOINT_BANKID_PRELOADED';

export const ENDPOINT_BANKID_READ_REQUEST = 'ENDPOINT_BANKID_READ_REQUEST';
export const ENDPOINT_BANKID_READ_SUCCESS = 'ENDPOINT_BANKID_READ_SUCCESS';
export const ENDPOINT_BANKID_READ_FAILURE = 'ENDPOINT_BANKID_READ_FAILURE';
export const ENDPOINT_BANKID_READ = [ENDPOINT_BANKID_READ_REQUEST, ENDPOINT_BANKID_READ_SUCCESS, ENDPOINT_BANKID_READ_FAILURE];

export const ENDPOINT_BANKID_DELETE_REQUEST = 'ENDPOINT_BANKID_DELETE_REQUEST';
export const ENDPOINT_BANKID_DELETE_SUCCESS = 'ENDPOINT_BANKID_DELETE_SUCCESS';
export const ENDPOINT_BANKID_DELETE_FAILURE = 'ENDPOINT_BANKID_DELETE_FAILURE';
export const ENDPOINT_BANKID_DELETE = [ENDPOINT_BANKID_DELETE_REQUEST, ENDPOINT_BANKID_DELETE_SUCCESS, ENDPOINT_BANKID_DELETE_FAILURE];

export const ENDPOINT_BANKID_EDIT_SETTINGS = 'ENDPOINT_BANKID_EDIT_SETTINGS';

export const ENDPOINT_BANKID_UPDATE_SETTINGS_REQUEST = 'ENDPOINT_BANKID_UPDATE_SETTINGS_REQUEST';
export const ENDPOINT_BANKID_UPDATE_SETTINGS_SUCCESS = 'ENDPOINT_BANKID_UPDATE_SETTINGS_SUCCESS';
export const ENDPOINT_BANKID_UPDATE_SETTINGS_FAILURE = 'ENDPOINT_BANKID_UPDATE_SETTINGS_FAILURE';
export const ENDPOINT_BANKID_UPDATE_SETTINGS = [ENDPOINT_BANKID_UPDATE_SETTINGS_REQUEST, ENDPOINT_BANKID_UPDATE_SETTINGS_SUCCESS, ENDPOINT_BANKID_UPDATE_SETTINGS_FAILURE];
